module.exports = __webpack_public_path__ + "static/media/delete-btn.a072ac05.svg";